// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content[data-v-2aa40abc]{padding:8px;display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;font-size:14px}.header[data-v-2aa40abc]{font-size:1.6em;margin-bottom:1em}.login[data-v-2aa40abc]{color:#28d;cursor:pointer;text-decoration:underline}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
